import * as React from 'react';
import { Text, Button } from "@chakra-ui/react"
import { SubmitButtonPropTypes } from "./SubmitButtonPropTypes"

export const SubmitButton = ({
    formProps,
    label = 'Submit',
    textProps = {},
    ...rest
}: SubmitButtonPropTypes.ISubmitButtonProps) => {
    const { dirty, valid } = formProps
    return (
        <Button
            type='submit'
            _hover={{ bg: 'brand.tertiary', color: 'brand.secondary' }}
            {...(dirty && valid) ? { bg: 'brand.lightTertiary', color: 'brand.secondary' } : { bg: 'brand.disabledTertiary', color: 'brand.secondary', pointerEvents: 'none', cursor: 'default' }}
            {...rest}>
            <Text textStyle='buttonSmall' {...textProps}>{label}</Text>
        </Button>
    )
}
